/* Native scrolling keeps the research readable before this enhancement loads. */
if (!customElements.get('jive-research-carousel')) {
  class JiveResearchCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-research-track]');
      this.previous = this.querySelector('[data-research-prev]');
      this.next = this.querySelector('[data-research-next]');
      this.count = this.querySelector('[data-research-count]');
      if (!this.track || !this.previous || !this.next || !this.count) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resize?.disconnect();
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.querySelector('[data-research-controls]').hidden = false;
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }

    step() {
      const cards = this.track.children;
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
    }

    move(direction) {
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: direction * this.step(), behavior });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const index = this.next.disabled && max > 2 ? this.track.children.length : Math.round(this.track.scrollLeft / Math.max(1, this.step())) + 1;
      this.count.textContent = `${Math.min(index, this.track.children.length)} / ${this.track.children.length}`;
    }
  }
  customElements.define('jive-research-carousel', JiveResearchCarousel);
}
